<div class="progress nk-progress" [attr.data-cy]="isLoading ? 'ui-loading' : ''" [class.opacity-0]="!isLoading">
  <div
    class="progress-bar progress-bar-striped progress-bar-animated bg-info w-100"
    role="progressbar"
    aria-valuenow="100"
    aria-valuemin="0"
    aria-valuemax="100"></div>
</div>
